import { FormRule } from "antd";

export const validatePhoneNumber = (_: FormRule, val: string) => {
  if (/^[+\d-\s)(]+$/.test(val)) {
    return Promise.resolve();
  }

  return Promise.reject(Error("Provided not allowed characters."));
};

export const validateId = (id?: string | number): number => {
  if (typeof id === "string") {
    return parseInt(id, 10);
  }

  return id || 0;
};
